<div class="title app-row full-width">
  <button type="button" class="btn btn-sm btn-primary" (click)="ShowSelectors()"><span
      class="fas fa-bars"></span></button>
  <label>Project Configuration</label>
  <button type="button" class="btn btn-sm btn-danger" (click)="Close()">
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="app-row full-width">
  <app-view-stack [viewName]="topView">
    <app-view-stack-view no-grow fit sticky sticky-unfit viewName="left-view">
      <app-view-stack id="project-config-vs-left-view" vertical [viewName]="leftView">
        <app-view-stack-view sticky vertical viewName="selectors">
          <div class="btn-group-vertical app-col sm-gap full-width center">
            <button data-view="general" (click)="HandleWSButton($event.target)" type="button"
              class="btn btn-sm btn-primary center">General</button>
            <button data-view="attributes" (click)="HandleWSButton($event.target)" type="button"
              class="btn btn-sm btn-primary center">Attributes</button>
            <button data-view="presets" (click)="HandleWSButton($event.target)" type="button"
              class="btn btn-sm btn-primary center">Presets</button>
            <button data-view="supplementals" (click)="HandleWSButton($event.target)" type="button"
              class="btn btn-sm unwrapped btn-primary center">Supplemental Fields</button>
            <div class="sm-gap app-row spread">
              <button (click)="SaveProject()" title="download" class="full-width btn btn-primary btn-sm" type="button">
                <span class="icon fas fa-save"></span>
                <label>Save</label>
              </button>
              <button (click)="LoadProject()" class="full-width btn  btn-primary btn-sm" type="button">
                <span class="icon fas fa-save"></span>
                <label>Load</label>
              </button>
            </div>
          </div>


        </app-view-stack-view>
        <app-view-stack-view id="project-config-vs-sub-selectors" viewName="sub-selectors">
          <app-view-stack [viewName]="subSelectorView">
            <app-view-stack-view viewName="attributes">
              <app-attribute-listing [updated]="this.lastUpdate" (projectChange)="Debug()" [project]="project" (selections)="ShowAttribute($event)"></app-attribute-listing>
            </app-view-stack-view>
            <app-view-stack-view viewName="presets">
              <app-preset-listing [project]="project" (presetSelected)="ShowPreset($event)"></app-preset-listing>
            </app-view-stack-view>
            <app-view-stack-view viewName="supplementals">
              <app-supplemental-listing></app-supplemental-listing>
            </app-view-stack-view>

          </app-view-stack>
        </app-view-stack-view>
      </app-view-stack>
    </app-view-stack-view>
    <app-view-stack-view  id="project-config-vs-workspaces" viewName="workspaces">
      <app-view-stack [viewName]="workspaceView">
        <app-view-stack-view viewName="general">
          <app-project-general-cfg-view [(config)]="projectConfig" (configChange)="Debug()">
          </app-project-general-cfg-view>
        </app-view-stack-view>
        <app-view-stack-view  viewName="attributes">
          <app-attribute-workspace [project]="project" [attribute]="selectedAttribute" (attributeChange)="AttributeUpdated($event)"></app-attribute-workspace>
        </app-view-stack-view>
        <app-view-stack-view viewName="preset">
          <app-preset-workspace  [project]="project" [preset]="selectedPreset" ></app-preset-workspace>
        </app-view-stack-view>
      </app-view-stack>
    </app-view-stack-view>
  </app-view-stack>
</div>
